export default __webpack_public_path__ + "static/media/frame-desktop.389a9123.webp";